import script from "./SearchHotel.vue?vue&type=script&setup=true&lang=js"
export * from "./SearchHotel.vue?vue&type=script&setup=true&lang=js"

import "./SearchHotel.vue?vue&type=style&index=0&id=7cce6716&scoped=true&lang=css"

import exportComponent from "/home/paiscaler-travelcrmdev/htdocs/travelcrmdev.paiscaler.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7cce6716"]])

export default __exports__